"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BrandLister_module_1 = require("./modules/BrandLister.module");
const loadBrandListerModule = (initialData) => ({
    hasRouter: true,
    modules: [(0, BrandLister_module_1.default)(initialData)],
});
exports.default = loadBrandListerModule;
